export default (optionValue, selectedValue) => (
  selectedValue && (Array.isArray(selectedValue) ? selectedValue.includes(optionValue) : selectedValue === optionValue)
)
